import React from "react";

import { ITeachingMaterial } from "../../../state";
import TeachingMaterial from "../../../organisms/student/TeachingMaterial";
import Header from "../../../organisms/student/Header";

import styles from "./MaterialsList.module.scss";

export interface IMaterialsListProps {
  teaching_materials: ITeachingMaterial[];
  directTo: (
    teaching_material_id: number,
    lesson_id: number,
    round_no: number,
  ) => void;
}

export const MaterialsList = (props: IMaterialsListProps) => {
  const materials = props.teaching_materials.filter(
    material => !material.title.includes("オリエンテーション"),
  );

  return (
    <>
      <div className={styles.wrapper} id="accordion">
        <Header />
        {materials.length > 0 ? (
          materials.map(material => (
            <TeachingMaterial
              key={material.id}
              teaching_material={material}
              directTo={props.directTo}
            />
          ))
        ) : (
          <div className={styles.messageContainer}>
            <p className={styles.message}>教材が開放されていません。</p>
          </div>
        )}
      </div>
    </>
  );
};

export default MaterialsList;
